import React from 'react';

const jQuery_CSS = () => {
  return (
    <div >
      <h1>jQuery_CSS</h1>
      <p>Placeholder component for: "jQuery CSS"</p>
    </div>
  );
};

export default jQuery_CSS;
